// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zhdvgqxwnjnjemgtsfrj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpoZHZncXh3bmpuamVtZ3RzZnJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY0MzEzMzEsImV4cCI6MjA1MjAwNzMzMX0.fJALVvUwkhUpeeCSKdNX3OVFg7_u8v_Cy1DD2vIEdFs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);